// extracted by mini-css-extract-plugin
module.exports = {"borderTop":"EmptyHint_borderTop__3vyjX","borderBottom":"EmptyHint_borderBottom__yk-bR"};